export default {"src":"/_next/static/media/mileprogram-rank-benefit-table.af581eb6.svg","height":401,"width":476,"blurWidth":0,"blurHeight":0};